import { Ability } from '@casl/ability'
import initial from './abilities/initial'

let permissions = new Ability(initial)

export default permissions
